import { isFieldErrorResponse, useApiTradeV1PackagingSpecificationsDestroy } from 'api';
import { useNotification } from 'features';

type Props = {
  onSuccess?: () => void;
};

export const useDeletePackagingSpecification = ({ onSuccess }: Props) => {
  const { open } = useNotification();
  const { mutate } = useApiTradeV1PackagingSpecificationsDestroy({
    mutation: {
      onError: (error) => {
        if (isFieldErrorResponse(error) && error.response?.data.non_field_errors) {
          open({
            description: error?.response?.data.non_field_errors[0],
            message: 'Error deleting packaging specification',
            type: 'error',
          });
          return;
        }

        open({
          message: 'Error deleting packaging specification',
          type: 'error',
        });
      },
      onSuccess: () => {
        onSuccess?.();
        open({
          message: 'Packaging specification deleted',
          type: 'success',
        });
      },
    },
  });

  const deletePackagingSpecification = (packagingSpecificationId: number) => {
    mutate({ packagingSpecificationId });
  };

  return { deletePackagingSpecification };
};
